import { PotentialCompetitors } from '@sales-app/context/workspace/workspace.type'
import { Agent } from '@sales-app/types/Agent'
import { BookablePerson } from '@sales-app/types/BookablePerson'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { DisplayCity } from '@sales-app/types/DisplayCity'
import { PersonPotentialBookingRow } from '@sales-app/views/Workspace/PersonSummary/PersonSummary.data'
import { gql } from 'graphql-request'

export namespace PotentialBookingQueries {
  export namespace GET_POTENTIAL_BOOKINGS {
    export type Response = { potentialBookings: PotentialBooking[] | null }
  }

  export namespace GET_POTENTIAL_BOOKING {
    export type Response = { potentialBooking: PotentialBooking | null }
  }
  export function getPotentialBookings() {
    return gql`
      query getPotentialBookings($filter: PotentialBookingFilter, $sortBy: PotentialBookingSort) {
        potentialBookings(filter: $filter, sortBy: $sortBy) {
          id
          airConditioning
          agent {
            name
          }
          agentId
          bedrooms
          beginningMoveInDate
          beginningMoveOutDate
          bookablePerson {
            fullName
            email
            phone
            bookablePersonType
            bookablePersonId
          }
          bookablePersonId
          bookablePersonType
          createdAt
          displayCityId
          elevator
          endingMoveInDate
          endingMoveOutDate
          gym
          maximumPrice
          minimumPrice
          parking
          petFriendly
          pool
          potentialBookingStatus
          potentialBookingStatusId
          potentialBookingSource
          potentialBookingSourceId
          reservationType
          notes
          displayCity {
            name
            slug
            id
          }
        }
      }
    `
  }

  export namespace GET_POTENTIAL_BOOKINGS_BY_BOOKABLE_PERSON {
    export type Response = { bookablePersonPotentialBookings: PersonPotentialBookingRow[] | null }
  }
  export function getPotentialBookingsByBookablePerson() {
    return gql`
      query getPotentialBookingsByBookablePerson($bookablePersonType: BookablePersonType, $bookablePersonId: Int!) {
        bookablePersonPotentialBookings(bookablePersonType: $bookablePersonType, bookablePersonId: $bookablePersonId) {
          id
          createdAt
          agent {
            name
          }
          bookablePersonId
          bookablePersonType
          potentialBookingStatus
          potentialBookingSource
          displayCity {
            name
            slug
            id
          }
        }
      }
    `
  }

  export function getPotentialBooking() {
    return gql`
      query getPotentialBooking($id: Int!) {
        potentialBooking(id: $id) {
          id
          airConditioning
          agent {
            name
          }
          agentId
          balcony
          bathrooms
          bedrooms
          beginningMoveInDate
          beginningMoveOutDate
          bookablePerson {
            fullName
            firstName
            lastName
            email
            phone
            bookablePersonType
            bookablePersonId
            utmSource
            hasDuplicates
          }
          bookablePersonId
          bookablePersonType
          createdAt
          displayCityId
          elevator
          endingMoveInDate
          endingMoveOutDate
          gym
          inUnitLaundry
          maximumPrice
          minimumPrice
          parking
          pending
          petFriendly
          pool
          potentialBookingStatus
          potentialBookingStatusId
          potentialBookingSource
          potentialBookingSourceId
          reservationType
          notes
          potentialCompetitors
          displayCity {
            name
            slug
            id
          }
        }
      }
    `
  }
}

export interface PotentialBookingRow {
  bookablePersonType: BookablePersonType
  createdAt: string
  displayCityId: number
  id: number
}

export interface PotentialBooking extends PotentialBookingRow {
  agent: Agent | null
  agentId: number | null
  airConditioning: null | boolean
  balcony: null | boolean
  bathrooms: null | number[]
  bedrooms: null | number[]
  beginningMoveInDate: null | string
  beginningMoveOutDate: null | string
  bookablePerson: BookablePerson | null
  bookablePersonId: number
  displayCity: DisplayCity
  elevator: null | boolean
  endingMoveInDate: null | string
  endingMoveOutDate: null | string
  gym: null | boolean
  inUnitLaundry: null | boolean
  maximumPrice: null
  minimumPrice: null
  notes: string | null
  parking: null | boolean
  pending?: boolean
  petFriendly: null
  pool: null
  potentialBookingSource: string
  potentialBookingSourceId: number
  potentialBookingStatus: PotentialBookingStatus
  potentialBookingStatusId: number
  potentialCompetitors: PotentialCompetitors[] | null
  reservationType: null
}

export enum PotentialBookingStatus {
  BOOKED = 'Booked',
  DENIED = 'Denied',
  NEW = 'New',
  NOT_INTERESTED = 'Not interested',
  ON_HOLD = 'On hold',
  PENDING = 'Pending',
  WORKING = 'Working',
}
